import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './../../config.service';
import { LenderBasicInfo } from '../../../model/lender.model';
import { InvestmentPreferences, UserAttributeInterface } from '../../../model/finzy-flex/user-attribute.model';

@Injectable()
export class UserAttributeService {
	private readonly httpClient: HttpClient;
	private readonly configService: ConfigService;

	constructor(httpClient: HttpClient, configService: ConfigService) {
		this.httpClient = httpClient;
		this.configService = configService;
	}

	public async getLenderBasicInfo(lender_id: string): Promise<LenderBasicInfo> {
		const url = `${this.configService.getUserService_V2_Url()}/lender/${lender_id}`;
		return await this.httpClient.get<LenderBasicInfo>(url).toPromise();
	}

	public async postUserAttribute(userAttribute: InvestmentPreferences, userId: string): Promise<UserAttributeInterface> {
		const url = `${this.configService.getUserService_V2_Url()}/user/${userId}/attributes`;
		return await this.httpClient.post<UserAttributeInterface>(url, userAttribute).toPromise();
	}

	public async putUserAttribute(userAttribute: InvestmentPreferences, userId: string): Promise<UserAttributeInterface> {
		const url = `${this.configService.getUserService_V2_Url()}/user/${userId}/attributes`;
		return await this.httpClient.put<UserAttributeInterface>(url, userAttribute).toPromise();
	}

	public async getUserAttributesById(userId: string): Promise<UserAttributeInterface> {
		const url = `${this.configService.getUserService_V2_Url()}/user/${userId}/attributes`;
		return await this.httpClient.get<UserAttributeInterface>(url).toPromise();
	}
}
